import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import api from "../services/axiosInstance";
import { backendPort } from "../components/Fungsiku";
import { useNotification } from './NotifPopup';

//DAFTAR CABANG
export function PageKonten22({token, search = "ATK"}) {
  const kosong = {id: '', akun: '', subakun:''};
  const [data, setData] = useState([{id: '', akun: '', subakun: ''}]);
  const [opsiAkun, setOpsiAkun] = useState([kosong]);
  const [dataNew, setDataNew] = useState(kosong);
  const [sortBy, setSortBy] = useState('nama'); // 'kode' | 'nama'
  const [sortDir, setSortDir] = useState('asc'); // asc | desc
  const [showTambah, setShowTambah] = useState(false); // asc | desc
  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState(kosong);
  const [showHapus, setShowHapus] = useState(false);
  const [hapusData, setHapusData] = useState(kosong);
  //const [search, setSearch] = useState("ATK");
  const { showNotif } = useNotification();
  const terisi = dataNew?.akun?.trim() !== '' && dataNew?.subakun?.trim() !== '';
  const [open, setOpen] = useState(2);
  const toggle = (id) => {
    setOpen(open === id ? null : id);
  };
  //PAGINATION
  const loadData = async () => {
    await api.get(
      `${backendPort}/api/master/p_subakun`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  .then(res => {
    const data = res.data;
    if(data){
      const opsi = Array.from(new Map(data.map(item => [item.akun, item])).values());
      setOpsiAkun(opsi);  
      setData(data);  
    }
    })
  .catch(err => console.error(err));
  };


  useEffect(() => {
    loadData();
  }, []);

  const handleTambah = async (e) => {
    try{
      setShowTambah(false);  
      e.preventDefault();
      console.log('kirim ke API= ',dataNew);  
      await api.post(`${backendPort}/api/master/tambah_subakun`, {
        akun: dataNew.akun,
        subakun: dataNew.subakun
      });
      setDataNew(kosong);
      await loadData();
      showNotif('success', 'Data Berhasil Ditambahkan');  
    } catch (err) {
      showNotif('error', 'Penambahan Data Gagal');
    }
  };
  
  const handleEdit = async (e) => {
    try{
      setShowEdit(false);  
      console.log('editData =', editData);  
      e.preventDefault();
      await api.put(
      `${backendPort}/api/master/edit_subakun/${editData.id}`,
      { 
        subakun: editData.subakun,
        id: editData.id
       });      
      showNotif('success', 'Update Data Berhasil');
      await loadData();
    }
    catch(e)
    {showNotif('error', 'Update Data Gagal');}
  };
  
  const handleDelete = async (e) => {
    try{
      setShowHapus(false);
      if (e) e.preventDefault();
      
      await api.delete(
      `${backendPort}/api/master/delete_subakun/${hapusData.id}`
      );

      showNotif('success', 'Delete Data Berhasil');
      
      loadData();
    }
    catch(e)
    {showNotif('error', 'Delete Data Gagal');}
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(field);
      setSortDir('asc');
    }
  };

const filteredData = useMemo(() => {
      return data.filter(item => {
        const searchMatch = item?.akun?.includes(search);
        return searchMatch;
      });
    }, [data, search]);

const sortedData =
 [...filteredData].sort((a, b) => {
  if (!sortBy) return 0;

  const getValA = () => {
    switch (sortBy) {
      case 'kolom1': return a.id;
      case 'kolom2': return a.akun;
      case 'kolom3': return a.subakun;
      default: return a.id;
    }
  };

  const getValB = () => {
    switch (sortBy) {
      case 'kolom1': return b.id;
      case 'kolom2': return b.akun;
      case 'kolom3': return b.subakun;
      default: return b.id;
    }
  };

  const valA = getValA();
  const valB = getValB();

  // number
  if (typeof valA === 'number' && typeof valB === 'number') {
    return sortDir === 'asc' ? valA - valB : valB - valA;
  }

  // string
  return sortDir === 'asc'
    ? String(valA).localeCompare(String(valB))
    : String(valB).localeCompare(String(valA));
});

  return (
   
      <div>
                {/* TABLE */}
          <div className="accordion-manual">              
                            {/*LPJ*/}
                            <div className="accordion-item">
                                <button
                                className="accordion-header text-white"
                                onClick={() => {
                                    setShowTambah(false); setShowEdit(false); setShowHapus(false);
                                    toggle(2)}}
                                >Daftar Sub Akun
                                {open === 2 ? <i className="fa fa-minus"></i> : <i className="fa fa-add"></i>}
                                </button>
                                <div className={`accordion-body ${open === 2 ? 'open' : ''}`}>
                                <div className="accordion-content">
                                    {/*KONTEN 2*/}
                                <div className="card-body p-0">
                                <div className="row flex justify-content-between align-center my-2">
                                    <div className="col-md-4">
                                    </div>
                                    <div className='col-md-4 text-end'>
                                      <button 
                                          className="btn btn-outline-dark ls"  
                                          onClick={()=>{
                                              console.log("akun",dataNew.akun);
                                              setShowTambah(!showTambah); 
                                              setShowEdit(false); 
                                              setShowHapus(false); 
                                              }}>Tambah <i className="fa fa-add"></i>
                                      </button>
                                    </div>  
                                </div>
                                <table className="table table-bordered table-hover">
                                    <thead>
                                    <tr>
                                        <th onClick={() => handleSort('kolom2')} style={{ cursor: 'pointer' }}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>Akun</span>
                                            {sortBy === 'kolom2' && (
                                            <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                                            )}
                                        </div>
                                        </th>
                                        
                                        <th onClick={() => handleSort('kolom1')} style={{ cursor: 'pointer' }}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>No Sub</span>
                                            {sortBy === 'kolom1' && (
                                            <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                                            )}
                                        </div>
                                        </th>

                                        <th onClick={() => handleSort('kolom3')} style={{ cursor: 'pointer' }}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>Sub Akun</span>
                                            {sortBy === 'kolom3' && (
                                            <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                                            )}
                                        </div>
                                        </th>

                                        <th width="80">Aksi</th>
                                    
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {sortedData.map((row) => (
                                        <tr key={row.id}>
                                            <td className='single-line'>{row.akun}</td>
                                            <td className='single-line'>{row.id}</td>
                                            <td className='single-line'>{row.subakun}</td>    
                                            <td className="d-flex justify-content-between align-items-center">
                                            <span onClick={async () => {
                                                await setEditData({
                                                    id: row.id, 
                                                    akun: row.akun,
                                                    subakun: row.subakun,
                                                });
                                                setShowEdit(!showEdit);
                                                setShowTambah(false);
                                                setShowHapus(false);
                                                }}
                                                style={{ cursor: 'pointer' }}>
                                                <i className="fa fa-solid fa-edit"></i>
                                                </span>

                                            <span onClick={async () => {
                                                setHapusData({
                                                    id: row.id,
                                                    akun: row.akun,
                                                    subakun: row.subakun
                                                });
                                                setShowHapus(!showHapus);
                                                setShowTambah(false);
                                                setShowEdit(false);
                                                }}
                                                style={{ cursor: 'pointer' }}>
                                                <i className="fa fa-trash text-red-500"></i>
                                                </span>
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                </table>
                                </div>
                                
                                    </div>
                                </div>
                              </div>  
          </div>




        {/* FORM TAMBAH*/}
        {showTambah && 
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.3)' }}
        ><div className="modal-dialog modal-dialog-centered">
        <div className="col-md-6 modal-content">
          <div className="card">
            <div className="card-header" style={{ background: "#09314F", color: "#fff"}}>
              Tambah Sub Akun Baru
            </div>
            <div className="card-body">
              <form>
                <div className="mb-3">
                  <label>Akun</label>
                  <select
                    className="form-select"
                    value={dataNew.akun}
                    onChange={e => setDataNew(prev=>({...prev, akun: e.target.value}))}
                  >
                    <option value = ''>-Pilih Akun-</option>
                    { 
                      opsiAkun.map(x => (
                      <option key={x.id} value={x.akun}>{x.akun}</option>
                    ))
                    }
                  </select>  
                </div>
                
                <div className="mb-3">
                  <label>Nama Sub Akun</label>
                  <input
                    className="form-control"
                    value={dataNew.subakun}
                    onChange={(e) => setDataNew(prev=>({...prev, subakun: e.target.value}))}
                  />
                </div>
                
                <button 
                    className="btn btn-primary me-2"
                    disabled = {!terisi}
                    onClick={handleTambah}
                  >Simpan</button>
                
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setDataNew(kosong);
                    setShowTambah(false);
                  }}
                >
                  Batal
                </button>
              </form>
            </div>
          </div>
        </div>
        </div></div>
        }

        {/* FORM Edit*/}
        {showEdit && <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.3)' }}
        ><div className="modal-dialog modal-dialog-centered">
        <div className="col-md-6 modal-content">
          <div className="card">
            <div className="card-header" style={{  background: "#09314F", color: "#fff" }}>
              Edit Data Sub Akun
            </div>
            <div className="card-body">
              <form>
                <div className="mb-3">
                <label>Akun</label>
                  <input
                    className="form-select"
                    value={editData.akun}
                    disabled
                    />  
                </div>


                <div className="mb-3">
                  <label>No Sub</label>
                  <input
                    className="form-control"
                    value={editData.id}
                    disabled
                  />
                </div>
                
                <div className="mb-3">
                  <label>Nama Sub Akun</label>
                  <input
                    className="form-control"
                    value={editData.subakun}
                    onChange={(e) => setEditData(prev => ({ ...prev, subakun: e.target.value }))}
                  />
                </div>

                <button className="btn btn-primary me-2"
                    disabled = {!terisi}
                    onClick={handleEdit}
                    >Update</button>
  
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setEditData(kosong);
                    setShowEdit(false);
                  }}
                > Batal</button>
              </form>
            </div>
          </div>
        </div></div></div>}

        {/* FORM Hapus*/}
        {showHapus && <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.3)' }}
        ><div className="modal-dialog modal-dialog-centered">
        <div className="col-md-6 modal-content">
          <div className="card">
            <div className="card-header" style={{ background: "#dc3545", color: "#fff" }}>
              Hapus Sub Akun
            </div>
            <div className="card-body">
              <form onSubmit={handleDelete}>
                <div className="mb-3">
                  <label>Akun</label>
                  <input
                    className="form-control"
                    value={hapusData.akun}
                    disabled
                  />
                </div>

                <div className="mb-3">
                  <label>No Sub</label>
                  <input
                    className="form-control"
                    value={hapusData.id}
                    disabled
                  />
                </div>
                
                <div className="mb-3">
                  <label>Nama Sub Akun</label>
                  <input
                    className="form-control"
                    value={hapusData.subakun}
                    disabled
                  />
                </div>

                <button className="btn btn-danger me-2" 
                    >Delete</button>
  
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setHapusData(kosong);
                    setShowHapus(false);
                  }}
                > Batal</button>
              </form>
            </div>
          </div>
        </div></div></div>}
        </div>

  );
}
